import React, {useState, useEffect} from "react";
import { useLocation, NavLink } from "react-router-dom";
import { BaseService } from "../../service";

import { Nav } from "react-bootstrap";

function Sidebar({ color, image, routes, open, onClose }) {
  const location = useLocation();
  const service = new BaseService();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active-route" : "";
  };

  const [profilData, setprofilData] = useState(null);

  const getProfileData = async () => {
    const profileData = await service.getProfile();
    if (profileData?.data?.message == "Success") {
      setprofilData(profileData?.data?.data);
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.replace("/");
  };

  return (
    <React.Fragment>
      <div
        className={`sidebar-container ${open ? "open" : ""}`}
        data-image={image}
        data-color={color}
      >
        <div
          className="sidebar-background"
          style={{
            backgroundImage: "url(" + image + ")",
          }}
        />

        <div className="sidebar">
          <div className="d-flex align-items-center">
            <button onClick={onClose} className="desktop-hide icon-button">
              <img
                src="/assets/img/menu.png"
                alt="Menu Icon"
                className="icon white-icon desktop-hide"
              />
            </button>
            <a href="/settings" className="simple-text logo-mini mx-1">
              <div className="logo-img">
                <img src="/assets/img/YesLogo.png" alt="..." />
              </div>
            </a>
          </div>
          <Nav>
            <li>
              <NavLink to="/settings" className="nav-link">
                <svg
                  className="svg-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="512"
                  height="512"
                >
                  <path
                    className={`${activeRoute("settings")}`}
                    d="M12,12A6,6,0,1,0,6,6,6.006,6.006,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Z"
                    fill="rgba(255, 255, 255, 0.7)"
                  />
                  <path
                    className={`${activeRoute("settings")}`}
                    d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z"
                    fill="rgba(255, 255, 255, 0.7)"
                  />
                </svg>

                <p className={`sidebar-item ${activeRoute("settings")}`}>
                  Account Settings
                </p>
              </NavLink>
            </li>

            <li>
              <NavLink to="/preferences" className="nav-link">
                <svg
                  className="svg-icon"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={`${activeRoute("preferences")}`}
                    d="M0 7.24341V14.0002C0.00249609 16.0702 1.67998 17.7477 3.75001 17.7502H14.25C16.32 17.7477 17.9975 16.0702 18 14.0002V7.16016L0 7.24341Z"
                    fill="white"
                    fillOpacity="0.7"
                  />
                  <path
                    className={`${activeRoute("preferences")}`}
                    d="M14.25 2.74998H9.35399C9.23801 2.75075 9.12336 2.72509 9.01874 2.67499L6.65174 1.48699C6.33927 1.33139 5.99505 1.25028 5.64599 1.25H3.74998C1.67998 1.25246 0.00249609 2.92994 0 4.99998V5.74322L17.8972 5.65996C17.5064 3.95963 15.9947 2.75346 14.25 2.74998Z"
                    fill="white"
                    fillOpacity="0.7"
                  />
                </svg>
                <p className={`sidebar-item ${activeRoute("preferences")}`}>
                  Preferences
                </p>
              </NavLink>
            </li>

            <li>
              <NavLink to="/subscriptions" className={`nav-link ${profilData?.company_id ? 'disabled' : ''}`}>
                <svg
                  className="svg-icon"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_146_10793)">
                    <path
                      className={`${activeRoute("subscriptions")}`}
                      d="M14.25 3.5H3.75C2.7558 3.50119 1.80267 3.89666 1.09966 4.59966C0.396661 5.30267 0.00119089 6.2558 0 7.25L0 11.75C0.00119089 12.7442 0.396661 13.6973 1.09966 14.4003C1.80267 15.1033 2.7558 15.4988 3.75 15.5H14.25C15.2442 15.4988 16.1973 15.1033 16.9003 14.4003C17.6033 13.6973 17.9988 12.7442 18 11.75V7.25C17.9988 6.2558 17.6033 5.30267 16.9003 4.59966C16.1973 3.89666 15.2442 3.50119 14.25 3.5ZM3 13.25C2.85166 13.25 2.70666 13.206 2.58332 13.1236C2.45999 13.0412 2.36386 12.9241 2.30709 12.787C2.25032 12.65 2.23547 12.4992 2.26441 12.3537C2.29335 12.2082 2.36478 12.0746 2.46967 11.9697C2.57456 11.8648 2.7082 11.7934 2.85368 11.7644C2.99917 11.7355 3.14997 11.7503 3.28701 11.8071C3.42406 11.8639 3.54119 11.96 3.6236 12.0833C3.70601 12.2067 3.75 12.3517 3.75 12.5C3.75 12.6989 3.67098 12.8897 3.53033 13.0303C3.38968 13.171 3.19891 13.25 3 13.25ZM3 7.25C2.85166 7.25 2.70666 7.20601 2.58332 7.1236C2.45999 7.04119 2.36386 6.92406 2.30709 6.78701C2.25032 6.64997 2.23547 6.49917 2.26441 6.35368C2.29335 6.2082 2.36478 6.07456 2.46967 5.96967C2.57456 5.86478 2.7082 5.79335 2.85368 5.76441C2.99917 5.73547 3.14997 5.75032 3.28701 5.80709C3.42406 5.86386 3.54119 5.95999 3.6236 6.08332C3.70601 6.20666 3.75 6.35166 3.75 6.5C3.75 6.69891 3.67098 6.88968 3.53033 7.03033C3.38968 7.17098 3.19891 7.25 3 7.25ZM9 12.5C8.40666 12.5 7.82664 12.3241 7.33329 11.9944C6.83994 11.6648 6.45542 11.1962 6.22836 10.6481C6.0013 10.0999 5.94189 9.49667 6.05764 8.91473C6.1734 8.33279 6.45912 7.79824 6.87868 7.37868C7.29824 6.95912 7.83279 6.6734 8.41473 6.55764C8.99667 6.44189 9.59987 6.5013 10.1481 6.72836C10.6962 6.95542 11.1648 7.33994 11.4944 7.83329C11.8241 8.32664 12 8.90666 12 9.5C12 10.2956 11.6839 11.0587 11.1213 11.6213C10.5587 12.1839 9.79565 12.5 9 12.5ZM15 13.25C14.8517 13.25 14.7067 13.206 14.5833 13.1236C14.46 13.0412 14.3639 12.9241 14.3071 12.787C14.2503 12.65 14.2355 12.4992 14.2644 12.3537C14.2934 12.2082 14.3648 12.0746 14.4697 11.9697C14.5746 11.8648 14.7082 11.7934 14.8537 11.7644C14.9992 11.7355 15.15 11.7503 15.287 11.8071C15.4241 11.8639 15.5412 11.96 15.6236 12.0833C15.706 12.2067 15.75 12.3517 15.75 12.5C15.75 12.6989 15.671 12.8897 15.5303 13.0303C15.3897 13.171 15.1989 13.25 15 13.25ZM15 7.25C14.8517 7.25 14.7067 7.20601 14.5833 7.1236C14.46 7.04119 14.3639 6.92406 14.3071 6.78701C14.2503 6.64997 14.2355 6.49917 14.2644 6.35368C14.2934 6.2082 14.3648 6.07456 14.4697 5.96967C14.5746 5.86478 14.7082 5.79335 14.8537 5.76441C14.9992 5.73547 15.15 5.75032 15.287 5.80709C15.4241 5.86386 15.5412 5.95999 15.6236 6.08332C15.706 6.20666 15.75 6.35166 15.75 6.5C15.75 6.69891 15.671 6.88968 15.5303 7.03033C15.3897 7.17098 15.1989 7.25 15 7.25ZM10.5 9.5C10.5 9.79667 10.412 10.0867 10.2472 10.3334C10.0824 10.58 9.84811 10.7723 9.57403 10.8858C9.29994 10.9994 8.99834 11.0291 8.70737 10.9712C8.41639 10.9133 8.14912 10.7704 7.93934 10.5607C7.72956 10.3509 7.5867 10.0836 7.52882 9.79264C7.47094 9.50166 7.50065 9.20006 7.61418 8.92597C7.72771 8.65189 7.91997 8.41762 8.16665 8.2528C8.41332 8.08797 8.70333 8 9 8C9.39782 8 9.77936 8.15804 10.0607 8.43934C10.342 8.72064 10.5 9.10218 10.5 9.5Z"
                      fill="white"
                      fillOpacity="0.7"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_146_10793">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className={`sidebar-item ${activeRoute("subscriptions")}`}>
                  Subscriptions
                </p>
              </NavLink>
            </li>

            <li>
              <NavLink to="/payment-history" className="nav-link">
                <svg
                  className="svg-icon"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_146_10796)">
                    <path
                      className={`${activeRoute("payment-history")}`}
                      d="M10.6363 0.656422C10.5281 0.636519 10.4169 0.640639 10.3106 0.668491C10.2042 0.696342 10.1052 0.747243 10.0207 0.817588C9.9362 0.887934 9.86819 0.976002 9.82149 1.07556C9.7748 1.17511 9.75057 1.28371 9.75052 1.39367V3.55292C8.84243 3.43245 7.9188 3.52272 7.05123 3.81674C6.18365 4.11075 5.39544 4.60062 4.7477 5.24836C4.09996 5.8961 3.6101 6.68431 3.31608 7.55188C3.02206 8.41946 2.93179 9.34309 3.05227 10.2512H0.893016C0.783056 10.2512 0.674453 10.2755 0.574899 10.3221C0.475346 10.3688 0.387277 10.4369 0.316932 10.5214C0.246587 10.6059 0.195686 10.7048 0.167834 10.8112C0.139983 10.9176 0.135863 11.0288 0.155766 11.1369C0.452773 12.7506 1.18524 14.2523 2.27397 15.4798C3.3627 16.7072 4.76626 17.6138 6.3329 18.1013C7.89953 18.5888 9.56964 18.6388 11.1626 18.2458C12.7556 17.8528 14.2109 17.0319 15.371 15.8717C16.5312 14.7115 17.3522 13.2563 17.7451 11.6633C18.1381 10.0703 18.0881 8.40019 17.6006 6.83355C17.1131 5.26691 16.2066 3.86335 14.9791 2.77462C13.7516 1.6859 12.2499 0.95343 10.6363 0.656422ZM9.00052 11.0012C8.73827 11.0004 8.48083 10.9308 8.25402 10.7991C8.0272 10.6675 7.83899 10.4785 7.70827 10.2512H6.00052C5.8016 10.2512 5.61084 10.1722 5.47019 10.0315C5.32953 9.89085 5.25052 9.70008 5.25052 9.50117C5.25052 9.30226 5.32953 9.11149 5.47019 8.97084C5.61084 8.83019 5.8016 8.75117 6.00052 8.75117H7.70827C7.83898 8.52649 8.02584 8.33963 8.25052 8.20892V5.75117C8.25052 5.55226 8.32953 5.36149 8.47019 5.22084C8.61084 5.08019 8.8016 5.00117 9.00052 5.00117C9.19943 5.00117 9.39019 5.08019 9.53085 5.22084C9.6715 5.36149 9.75052 5.55226 9.75052 5.75117V8.20892C10.0366 8.37326 10.2603 8.62759 10.3868 8.9323C10.5133 9.23701 10.5355 9.57499 10.4499 9.89362C10.3643 10.2122 10.1758 10.4936 9.91361 10.694C9.65146 10.8943 9.33043 11.0023 9.00052 11.0012ZM7.47952 0.576172C7.62785 0.576172 7.77286 0.620159 7.89619 0.70257C8.01953 0.784981 8.11566 0.902115 8.17243 1.03916C8.22919 1.1762 8.24404 1.327 8.21511 1.47249C8.18617 1.61798 8.11474 1.75161 8.00985 1.8565C7.90496 1.96139 7.77132 2.03282 7.62583 2.06176C7.48035 2.0907 7.32955 2.07585 7.1925 2.01908C7.05546 1.96232 6.93832 1.86619 6.85591 1.74285C6.7735 1.61951 6.72952 1.47451 6.72952 1.32617C6.72952 1.12726 6.80853 0.936494 6.94919 0.795842C7.08984 0.65519 7.2806 0.576172 7.47952 0.576172ZM4.40452 1.89317C4.55285 1.89317 4.69786 1.93716 4.82119 2.01957C4.94453 2.10198 5.04066 2.21911 5.09743 2.35616C5.15419 2.4932 5.16904 2.644 5.1401 2.78949C5.11117 2.93498 5.03974 3.06861 4.93485 3.1735C4.82996 3.27839 4.69632 3.34982 4.55083 3.37876C4.40535 3.4077 4.25455 3.39285 4.1175 3.33608C3.98046 3.27932 3.86332 3.18319 3.78091 3.05985C3.6985 2.93651 3.65452 2.79151 3.65452 2.64317C3.65412 2.44439 3.73265 2.25358 3.87286 2.11267C4.01307 1.97175 4.20348 1.89227 4.40227 1.89167L4.40452 1.89317ZM2.08477 4.13192C2.2331 4.13192 2.37811 4.17591 2.50144 4.25832C2.62478 4.34073 2.72091 4.45786 2.77768 4.59491C2.83444 4.73195 2.84929 4.88275 2.82035 5.02824C2.79142 5.17373 2.71999 5.30736 2.6151 5.41225C2.51021 5.51714 2.37657 5.58857 2.23108 5.61751C2.0856 5.64645 1.9348 5.6316 1.79775 5.57483C1.66071 5.51807 1.54357 5.42194 1.46116 5.2986C1.37875 5.17526 1.33477 5.03026 1.33477 4.88192C1.33477 4.68301 1.41378 4.49224 1.55444 4.35159C1.69509 4.21094 1.88585 4.13192 2.08477 4.13192ZM0.884766 7.25717C1.0331 7.25717 1.17811 7.30116 1.30144 7.38357C1.42478 7.46598 1.52091 7.58311 1.57768 7.72016C1.63444 7.8572 1.64929 8.008 1.62035 8.15349C1.59142 8.29898 1.51999 8.43261 1.4151 8.5375C1.31021 8.64239 1.17657 8.71382 1.03108 8.74276C0.885598 8.7717 0.734798 8.75685 0.597753 8.70008C0.460708 8.64332 0.343574 8.54719 0.261163 8.42385C0.178752 8.30051 0.134766 8.15551 0.134766 8.00717C0.134765 7.80852 0.213577 7.61798 0.353905 7.47737C0.494233 7.33676 0.684613 7.25757 0.883266 7.25717H0.884766Z"
                      fill="white"
                      fillOpacity="0.7"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_146_10796">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p className={`sidebar-item ${activeRoute("payment-history")}`}>
                  Payment History
                </p>
              </NavLink>
            </li>

            <li>
              <NavLink to="/statistics" className="nav-link">
                <svg
                  className="svg-icon"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_146_10799)">
                    <path
                      className={`${activeRoute("statistics")}`}
                      d="M4.125 16.25C3.62772 16.25 3.15081 16.0525 2.79917 15.7008C2.44754 15.3492 2.25 14.8723 2.25 14.375V1.625C2.25 1.32663 2.13147 1.04048 1.9205 0.829505C1.70952 0.618526 1.42337 0.5 1.125 0.5V0.5C0.826631 0.5 0.540483 0.618526 0.329505 0.829505C0.118526 1.04048 0 1.32663 0 1.625L0 14.375C0 15.469 0.434597 16.5182 1.20818 17.2918C1.98177 18.0654 3.03098 18.5 4.125 18.5H16.875C17.1734 18.5 17.4595 18.3815 17.6705 18.1705C17.8815 17.9595 18 17.6734 18 17.375C18 17.0766 17.8815 16.7905 17.6705 16.5795C17.4595 16.3685 17.1734 16.25 16.875 16.25H4.125Z"
                      fill="rgba(255, 255, 255, 0.7)"
                    />
                    <path
                      className={`${activeRoute("statistics")}`}
                      d="M14.625 14C14.9234 14 15.2095 13.8815 15.4205 13.6705C15.6315 13.4595 15.75 13.1734 15.75 12.875V8.375C15.75 8.07663 15.6315 7.79048 15.4205 7.5795C15.2095 7.36853 14.9234 7.25 14.625 7.25C14.3266 7.25 14.0405 7.36853 13.8295 7.5795C13.6185 7.79048 13.5 8.07663 13.5 8.375V12.875C13.5 13.1734 13.6185 13.4595 13.8295 13.6705C14.0405 13.8815 14.3266 14 14.625 14Z"
                      fill="rgba(255, 255, 255, 0.7)"
                    />
                    <path
                      className={`${activeRoute("statistics")}`}
                      d="M5.625 14C5.92337 14 6.20952 13.8815 6.4205 13.6705C6.63147 13.4595 6.75 13.1734 6.75 12.875V8.375C6.75 8.07663 6.63147 7.79048 6.4205 7.5795C6.20952 7.36853 5.92337 7.25 5.625 7.25C5.32663 7.25 5.04048 7.36853 4.8295 7.5795C4.61853 7.79048 4.5 8.07663 4.5 8.375V12.875C4.5 13.1734 4.61853 13.4595 4.8295 13.6705C5.04048 13.8815 5.32663 14 5.625 14Z"
                      fill="rgba(255, 255, 255, 0.7)"
                    />
                    <path
                      className={`${activeRoute("statistics")}`}
                      d="M10.125 14C10.4234 14 10.7095 13.8815 10.9205 13.6705C11.1315 13.4595 11.25 13.1734 11.25 12.875V4.625C11.25 4.32663 11.1315 4.04048 10.9205 3.8295C10.7095 3.61853 10.4234 3.5 10.125 3.5C9.82663 3.5 9.54048 3.61853 9.3295 3.8295C9.11853 4.04048 9 4.32663 9 4.625V12.875C9 13.1734 9.11853 13.4595 9.3295 13.6705C9.54048 13.8815 9.82663 14 10.125 14Z"
                      fill="rgba(255, 255, 255, 0.7)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_146_10799">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className={`sidebar-item ${activeRoute("statistics")}`}>
                  Activity Statistic
                </p>
              </NavLink>
            </li>

            <div className="logout">
              <button onClick={handleLogout}>
                <img
                  style={{ marginRight: "10px", marginTop: "-7px" }}
                  src="/assets/img/logoutArrow.png"
                  alt="..."
                />
                Logout
              </button>
            </div>
          </Nav>
        </div>
      </div>
    </React.Fragment>
    // <div className="sidebar" data-image={image} data-color={color}>
    //   <div
    //     className="sidebar-background"
    //     style={{
    //       backgroundImage: "url(" + image + ")",
    //     }}
    //   />
    //   <div className="sidebar-wrapper">
    //     <div className="align-items-center ">
    //       <a href="/settings" className="simple-text logo-mini mx-1">
    //         <div className="logo-img">
    //           <img src="/assets/img/YesLogo.png" alt="..." />
    //         </div>
    //       </a>
    //     </div>
    //     <Nav>
    //       <li>
    //         <NavLink to="/settings" className="nav-link">
    //           <svg
    //             className="svg-icon"
    //             xmlns="http://www.w3.org/2000/svg"
    //             id="Outline"
    //             viewBox="0 0 24 24"
    //             width="512"
    //             height="512"
    //           >
    //             <path
    //               className={`${activeRoute("settings")}`}
    //               d="M12,12A6,6,0,1,0,6,6,6.006,6.006,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Z"
    //               fill="rgba(255, 255, 255, 0.7)"
    //             />
    //             <path
    //               className={`${activeRoute("settings")}`}
    //               d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z"
    //               fill="rgba(255, 255, 255, 0.7)"
    //             />
    //           </svg>

    //           <p className={`sidebar-item ${activeRoute("settings")}`}>
    //             Account Settings
    //           </p>
    //         </NavLink>
    //       </li>

    //       <li>
    //         <NavLink to="/preferences" className="nav-link">
    //           <svg
    //             className="svg-icon"
    //             width="18"
    //             height="19"
    //             viewBox="0 0 18 19"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path
    //               className={`${activeRoute("preferences")}`}
    //               d="M0 7.24341V14.0002C0.00249609 16.0702 1.67998 17.7477 3.75001 17.7502H14.25C16.32 17.7477 17.9975 16.0702 18 14.0002V7.16016L0 7.24341Z"
    //               fill="white"
    //               fill-opacity="0.7"
    //             />
    //             <path
    //               className={`${activeRoute("preferences")}`}
    //               d="M14.25 2.74998H9.35399C9.23801 2.75075 9.12336 2.72509 9.01874 2.67499L6.65174 1.48699C6.33927 1.33139 5.99505 1.25028 5.64599 1.25H3.74998C1.67998 1.25246 0.00249609 2.92994 0 4.99998V5.74322L17.8972 5.65996C17.5064 3.95963 15.9947 2.75346 14.25 2.74998Z"
    //               fill="white"
    //               fill-opacity="0.7"
    //             />
    //           </svg>
    //           <p className={`sidebar-item ${activeRoute("preferences")}`}>
    //             Preferences
    //           </p>
    //         </NavLink>
    //       </li>

    //       <li>
    //         <NavLink to="/subscriptions" className="nav-link">
    //           <svg
    //             className="svg-icon"
    //             width="18"
    //             height="19"
    //             viewBox="0 0 18 19"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <g clip-path="url(#clip0_146_10793)">
    //               <path
    //                 className={`${activeRoute("subscriptions")}`}
    //                 d="M14.25 3.5H3.75C2.7558 3.50119 1.80267 3.89666 1.09966 4.59966C0.396661 5.30267 0.00119089 6.2558 0 7.25L0 11.75C0.00119089 12.7442 0.396661 13.6973 1.09966 14.4003C1.80267 15.1033 2.7558 15.4988 3.75 15.5H14.25C15.2442 15.4988 16.1973 15.1033 16.9003 14.4003C17.6033 13.6973 17.9988 12.7442 18 11.75V7.25C17.9988 6.2558 17.6033 5.30267 16.9003 4.59966C16.1973 3.89666 15.2442 3.50119 14.25 3.5ZM3 13.25C2.85166 13.25 2.70666 13.206 2.58332 13.1236C2.45999 13.0412 2.36386 12.9241 2.30709 12.787C2.25032 12.65 2.23547 12.4992 2.26441 12.3537C2.29335 12.2082 2.36478 12.0746 2.46967 11.9697C2.57456 11.8648 2.7082 11.7934 2.85368 11.7644C2.99917 11.7355 3.14997 11.7503 3.28701 11.8071C3.42406 11.8639 3.54119 11.96 3.6236 12.0833C3.70601 12.2067 3.75 12.3517 3.75 12.5C3.75 12.6989 3.67098 12.8897 3.53033 13.0303C3.38968 13.171 3.19891 13.25 3 13.25ZM3 7.25C2.85166 7.25 2.70666 7.20601 2.58332 7.1236C2.45999 7.04119 2.36386 6.92406 2.30709 6.78701C2.25032 6.64997 2.23547 6.49917 2.26441 6.35368C2.29335 6.2082 2.36478 6.07456 2.46967 5.96967C2.57456 5.86478 2.7082 5.79335 2.85368 5.76441C2.99917 5.73547 3.14997 5.75032 3.28701 5.80709C3.42406 5.86386 3.54119 5.95999 3.6236 6.08332C3.70601 6.20666 3.75 6.35166 3.75 6.5C3.75 6.69891 3.67098 6.88968 3.53033 7.03033C3.38968 7.17098 3.19891 7.25 3 7.25ZM9 12.5C8.40666 12.5 7.82664 12.3241 7.33329 11.9944C6.83994 11.6648 6.45542 11.1962 6.22836 10.6481C6.0013 10.0999 5.94189 9.49667 6.05764 8.91473C6.1734 8.33279 6.45912 7.79824 6.87868 7.37868C7.29824 6.95912 7.83279 6.6734 8.41473 6.55764C8.99667 6.44189 9.59987 6.5013 10.1481 6.72836C10.6962 6.95542 11.1648 7.33994 11.4944 7.83329C11.8241 8.32664 12 8.90666 12 9.5C12 10.2956 11.6839 11.0587 11.1213 11.6213C10.5587 12.1839 9.79565 12.5 9 12.5ZM15 13.25C14.8517 13.25 14.7067 13.206 14.5833 13.1236C14.46 13.0412 14.3639 12.9241 14.3071 12.787C14.2503 12.65 14.2355 12.4992 14.2644 12.3537C14.2934 12.2082 14.3648 12.0746 14.4697 11.9697C14.5746 11.8648 14.7082 11.7934 14.8537 11.7644C14.9992 11.7355 15.15 11.7503 15.287 11.8071C15.4241 11.8639 15.5412 11.96 15.6236 12.0833C15.706 12.2067 15.75 12.3517 15.75 12.5C15.75 12.6989 15.671 12.8897 15.5303 13.0303C15.3897 13.171 15.1989 13.25 15 13.25ZM15 7.25C14.8517 7.25 14.7067 7.20601 14.5833 7.1236C14.46 7.04119 14.3639 6.92406 14.3071 6.78701C14.2503 6.64997 14.2355 6.49917 14.2644 6.35368C14.2934 6.2082 14.3648 6.07456 14.4697 5.96967C14.5746 5.86478 14.7082 5.79335 14.8537 5.76441C14.9992 5.73547 15.15 5.75032 15.287 5.80709C15.4241 5.86386 15.5412 5.95999 15.6236 6.08332C15.706 6.20666 15.75 6.35166 15.75 6.5C15.75 6.69891 15.671 6.88968 15.5303 7.03033C15.3897 7.17098 15.1989 7.25 15 7.25ZM10.5 9.5C10.5 9.79667 10.412 10.0867 10.2472 10.3334C10.0824 10.58 9.84811 10.7723 9.57403 10.8858C9.29994 10.9994 8.99834 11.0291 8.70737 10.9712C8.41639 10.9133 8.14912 10.7704 7.93934 10.5607C7.72956 10.3509 7.5867 10.0836 7.52882 9.79264C7.47094 9.50166 7.50065 9.20006 7.61418 8.92597C7.72771 8.65189 7.91997 8.41762 8.16665 8.2528C8.41332 8.08797 8.70333 8 9 8C9.39782 8 9.77936 8.15804 10.0607 8.43934C10.342 8.72064 10.5 9.10218 10.5 9.5Z"
    //                 fill="white"
    //                 fill-opacity="0.7"
    //               />
    //             </g>
    //             <defs>
    //               <clipPath id="clip0_146_10793">
    //                 <rect
    //                   width="18"
    //                   height="18"
    //                   fill="white"
    //                   transform="translate(0 0.5)"
    //                 />
    //               </clipPath>
    //             </defs>
    //           </svg>
    //           <p className={`sidebar-item ${activeRoute("subscriptions")}`}>
    //             Subscriptions
    //           </p>
    //         </NavLink>
    //       </li>

    //       <li>
    //         <NavLink to="/payment-history" className="nav-link">
    //           <svg
    //             className="svg-icon"
    //             width="18"
    //             height="19"
    //             viewBox="0 0 18 19"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <g clip-path="url(#clip0_146_10796)">
    //               <path
    //                 className={`${activeRoute("payment-history")}`}
    //                 d="M10.6363 0.656422C10.5281 0.636519 10.4169 0.640639 10.3106 0.668491C10.2042 0.696342 10.1052 0.747243 10.0207 0.817588C9.9362 0.887934 9.86819 0.976002 9.82149 1.07556C9.7748 1.17511 9.75057 1.28371 9.75052 1.39367V3.55292C8.84243 3.43245 7.9188 3.52272 7.05123 3.81674C6.18365 4.11075 5.39544 4.60062 4.7477 5.24836C4.09996 5.8961 3.6101 6.68431 3.31608 7.55188C3.02206 8.41946 2.93179 9.34309 3.05227 10.2512H0.893016C0.783056 10.2512 0.674453 10.2755 0.574899 10.3221C0.475346 10.3688 0.387277 10.4369 0.316932 10.5214C0.246587 10.6059 0.195686 10.7048 0.167834 10.8112C0.139983 10.9176 0.135863 11.0288 0.155766 11.1369C0.452773 12.7506 1.18524 14.2523 2.27397 15.4798C3.3627 16.7072 4.76626 17.6138 6.3329 18.1013C7.89953 18.5888 9.56964 18.6388 11.1626 18.2458C12.7556 17.8528 14.2109 17.0319 15.371 15.8717C16.5312 14.7115 17.3522 13.2563 17.7451 11.6633C18.1381 10.0703 18.0881 8.40019 17.6006 6.83355C17.1131 5.26691 16.2066 3.86335 14.9791 2.77462C13.7516 1.6859 12.2499 0.95343 10.6363 0.656422ZM9.00052 11.0012C8.73827 11.0004 8.48083 10.9308 8.25402 10.7991C8.0272 10.6675 7.83899 10.4785 7.70827 10.2512H6.00052C5.8016 10.2512 5.61084 10.1722 5.47019 10.0315C5.32953 9.89085 5.25052 9.70008 5.25052 9.50117C5.25052 9.30226 5.32953 9.11149 5.47019 8.97084C5.61084 8.83019 5.8016 8.75117 6.00052 8.75117H7.70827C7.83898 8.52649 8.02584 8.33963 8.25052 8.20892V5.75117C8.25052 5.55226 8.32953 5.36149 8.47019 5.22084C8.61084 5.08019 8.8016 5.00117 9.00052 5.00117C9.19943 5.00117 9.39019 5.08019 9.53085 5.22084C9.6715 5.36149 9.75052 5.55226 9.75052 5.75117V8.20892C10.0366 8.37326 10.2603 8.62759 10.3868 8.9323C10.5133 9.23701 10.5355 9.57499 10.4499 9.89362C10.3643 10.2122 10.1758 10.4936 9.91361 10.694C9.65146 10.8943 9.33043 11.0023 9.00052 11.0012ZM7.47952 0.576172C7.62785 0.576172 7.77286 0.620159 7.89619 0.70257C8.01953 0.784981 8.11566 0.902115 8.17243 1.03916C8.22919 1.1762 8.24404 1.327 8.21511 1.47249C8.18617 1.61798 8.11474 1.75161 8.00985 1.8565C7.90496 1.96139 7.77132 2.03282 7.62583 2.06176C7.48035 2.0907 7.32955 2.07585 7.1925 2.01908C7.05546 1.96232 6.93832 1.86619 6.85591 1.74285C6.7735 1.61951 6.72952 1.47451 6.72952 1.32617C6.72952 1.12726 6.80853 0.936494 6.94919 0.795842C7.08984 0.65519 7.2806 0.576172 7.47952 0.576172ZM4.40452 1.89317C4.55285 1.89317 4.69786 1.93716 4.82119 2.01957C4.94453 2.10198 5.04066 2.21911 5.09743 2.35616C5.15419 2.4932 5.16904 2.644 5.1401 2.78949C5.11117 2.93498 5.03974 3.06861 4.93485 3.1735C4.82996 3.27839 4.69632 3.34982 4.55083 3.37876C4.40535 3.4077 4.25455 3.39285 4.1175 3.33608C3.98046 3.27932 3.86332 3.18319 3.78091 3.05985C3.6985 2.93651 3.65452 2.79151 3.65452 2.64317C3.65412 2.44439 3.73265 2.25358 3.87286 2.11267C4.01307 1.97175 4.20348 1.89227 4.40227 1.89167L4.40452 1.89317ZM2.08477 4.13192C2.2331 4.13192 2.37811 4.17591 2.50144 4.25832C2.62478 4.34073 2.72091 4.45786 2.77768 4.59491C2.83444 4.73195 2.84929 4.88275 2.82035 5.02824C2.79142 5.17373 2.71999 5.30736 2.6151 5.41225C2.51021 5.51714 2.37657 5.58857 2.23108 5.61751C2.0856 5.64645 1.9348 5.6316 1.79775 5.57483C1.66071 5.51807 1.54357 5.42194 1.46116 5.2986C1.37875 5.17526 1.33477 5.03026 1.33477 4.88192C1.33477 4.68301 1.41378 4.49224 1.55444 4.35159C1.69509 4.21094 1.88585 4.13192 2.08477 4.13192ZM0.884766 7.25717C1.0331 7.25717 1.17811 7.30116 1.30144 7.38357C1.42478 7.46598 1.52091 7.58311 1.57768 7.72016C1.63444 7.8572 1.64929 8.008 1.62035 8.15349C1.59142 8.29898 1.51999 8.43261 1.4151 8.5375C1.31021 8.64239 1.17657 8.71382 1.03108 8.74276C0.885598 8.7717 0.734798 8.75685 0.597753 8.70008C0.460708 8.64332 0.343574 8.54719 0.261163 8.42385C0.178752 8.30051 0.134766 8.15551 0.134766 8.00717C0.134765 7.80852 0.213577 7.61798 0.353905 7.47737C0.494233 7.33676 0.684613 7.25757 0.883266 7.25717H0.884766Z"
    //                 fill="white"
    //                 fill-opacity="0.7"
    //               />
    //             </g>
    //             <defs>
    //               <clipPath id="clip0_146_10796">
    //                 <rect
    //                   width="18"
    //                   height="18"
    //                   fill="white"
    //                   transform="translate(0 0.5)"
    //                 />
    //               </clipPath>
    //             </defs>
    //           </svg>

    //           <p className={`sidebar-item ${activeRoute("payment-history")}`}>
    //             Payment History
    //           </p>
    //         </NavLink>
    //       </li>

    //       <li>
    //         <NavLink to="/statistics" className="nav-link">
    //           <svg
    //             className="svg-icon"
    //             width="18"
    //             height="19"
    //             viewBox="0 0 18 19"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <g clip-path="url(#clip0_146_10799)">
    //               <path
    //                 className={`${activeRoute("statistics")}`}
    //                 d="M4.125 16.25C3.62772 16.25 3.15081 16.0525 2.79917 15.7008C2.44754 15.3492 2.25 14.8723 2.25 14.375V1.625C2.25 1.32663 2.13147 1.04048 1.9205 0.829505C1.70952 0.618526 1.42337 0.5 1.125 0.5V0.5C0.826631 0.5 0.540483 0.618526 0.329505 0.829505C0.118526 1.04048 0 1.32663 0 1.625L0 14.375C0 15.469 0.434597 16.5182 1.20818 17.2918C1.98177 18.0654 3.03098 18.5 4.125 18.5H16.875C17.1734 18.5 17.4595 18.3815 17.6705 18.1705C17.8815 17.9595 18 17.6734 18 17.375C18 17.0766 17.8815 16.7905 17.6705 16.5795C17.4595 16.3685 17.1734 16.25 16.875 16.25H4.125Z"
    //                 fill="rgba(255, 255, 255, 0.7)"
    //               />
    //               <path
    //                 className={`${activeRoute("statistics")}`}
    //                 d="M14.625 14C14.9234 14 15.2095 13.8815 15.4205 13.6705C15.6315 13.4595 15.75 13.1734 15.75 12.875V8.375C15.75 8.07663 15.6315 7.79048 15.4205 7.5795C15.2095 7.36853 14.9234 7.25 14.625 7.25C14.3266 7.25 14.0405 7.36853 13.8295 7.5795C13.6185 7.79048 13.5 8.07663 13.5 8.375V12.875C13.5 13.1734 13.6185 13.4595 13.8295 13.6705C14.0405 13.8815 14.3266 14 14.625 14Z"
    //                 fill="rgba(255, 255, 255, 0.7)"
    //               />
    //               <path
    //                 className={`${activeRoute("statistics")}`}
    //                 d="M5.625 14C5.92337 14 6.20952 13.8815 6.4205 13.6705C6.63147 13.4595 6.75 13.1734 6.75 12.875V8.375C6.75 8.07663 6.63147 7.79048 6.4205 7.5795C6.20952 7.36853 5.92337 7.25 5.625 7.25C5.32663 7.25 5.04048 7.36853 4.8295 7.5795C4.61853 7.79048 4.5 8.07663 4.5 8.375V12.875C4.5 13.1734 4.61853 13.4595 4.8295 13.6705C5.04048 13.8815 5.32663 14 5.625 14Z"
    //                 fill="rgba(255, 255, 255, 0.7)"
    //               />
    //               <path
    //                 className={`${activeRoute("statistics")}`}
    //                 d="M10.125 14C10.4234 14 10.7095 13.8815 10.9205 13.6705C11.1315 13.4595 11.25 13.1734 11.25 12.875V4.625C11.25 4.32663 11.1315 4.04048 10.9205 3.8295C10.7095 3.61853 10.4234 3.5 10.125 3.5C9.82663 3.5 9.54048 3.61853 9.3295 3.8295C9.11853 4.04048 9 4.32663 9 4.625V12.875C9 13.1734 9.11853 13.4595 9.3295 13.6705C9.54048 13.8815 9.82663 14 10.125 14Z"
    //                 fill="rgba(255, 255, 255, 0.7)"
    //               />
    //             </g>
    //             <defs>
    //               <clipPath id="clip0_146_10799">
    //                 <rect
    //                   width="18"
    //                   height="18"
    //                   fill="white"
    //                   transform="translate(0 0.5)"
    //                 />
    //               </clipPath>
    //             </defs>
    //           </svg>
    //           <p className={`sidebar-item ${activeRoute("statistics")}`}>
    //             Activity Statistic
    //           </p>
    //         </NavLink>
    //       </li>
    //     </Nav>

    //     <div className="logout">
    //       <button onClick={() => handleLogout()}>
    //         <img
    //           style={{ marginRight: "10px", marginTop: "-7px" }}
    //           src="/assets/img/logoutArrow.png"
    //           alt="..."
    //         />
    //         Logout
    //       </button>
    //     </div>
    //   </div>
    // </div>
  );
}

export default Sidebar;
